export default __webpack_public_path__ + "static/media/open-icon.5cb9c5b1.svg";